import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://sndiitvbohvjvnvmebeh.supabase.co';
const supabaseKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNuZGlpdHZib2h2anZudm1lYmVoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjI5NjQwOTAsImV4cCI6MjAzODU0MDA5MH0.q3XYQWFcQ7LNWXKtHqs9XsUd3KsAnpjBBkD2tvQvzXE';

const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
